import { Typography } from '@mui/material'
import React, { useContext } from 'react'
import { Card, CardBody, Col, Container, Row } from 'reactstrap'
import { Icon } from "@progress/kendo-react-common";
import ErrorBoundary from '../../ErrorBoundry';
import { useWebSocket } from '../../WebsocketManager/WebSocketContext';
import ActivityPage from './ActivityPage';
import LeaveApplicationContext from "../../_helper/Customizer";
import "../Backbutton/backbutton.css";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { Btn } from '../../AbstractElements';


const ActivityList = () => {
  const { toggleIcon, toggleSidebar } = useContext(LeaveApplicationContext);
  const openCloseSidebar = () => {
    toggleSidebar(!toggleIcon);
  };

  return (
    <ErrorBoundary>
			<Row className="bg-primary py-2 mb-2">
            <Typography variant="h5"
              style={{ display: "flex", alignItems: "center" }}
            >
              {/* <Icon style={{ fontSize: '25px', margin:"10px"}} name="file-data" /> */}
              {!toggleIcon ? (
                  <Icon
                    size="medium"
                    style={{
                      fontSize: "25px",
                      margin: "10px",
                    }}
                    name="file-data"
                  />
                ) : (
                  <Tooltip
                    anchorElement="target"
                    position="top"
                    style={{ marginLeft: "10px" }}
                  >
                    <Btn
                      attrBtn={{
                        color: "primary",
                        onClick: () => {
                          openCloseSidebar();
                        },
                        className: "custom-back-button",
                        title: "Back to Menu",
                        style: {
                          fontSize: "18px",
                          outline: "1px solid white",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: "4px 8px",
                          paddingRight: "10px",
                          // fontSize: '1rem',
                          cursor: "pointer",
                          marginRight: "6px",
                        },
                      }}
                    >
                      <Icon
                        size="medium"
                        style={{
                          fontSize: "25px",
                          marginRight: "5px",
                          // cursor:"pointer",
                        }}
                        name="arrow-left"
                        onClick={openCloseSidebar}
                      />
                      Back
                    </Btn>
                  </Tooltip>
                )}
              {/* <Icon
                style={{ fontSize: "25px", margin: "10px" }}
                name="file-data"
              /> */}
              Activity
            </Typography>
          </Row>
    <Container fluid={true}>
          <Row>
            <Col sm="12" className="page-content">
              <Card>
                <CardBody>
                    <div style={{padding:"10px 20px"}}>
                    <ActivityPage showFilter={true}/>
                    </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
		</Container>
        </ErrorBoundary>
  )
}

export default ActivityList
